var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.blockType,{tag:"component",attrs:{"block-data":_vm.data,"slideNum":_vm.slideNum,"text-dir":_vm.textDir,"is-rtl":_vm.isRtl,"active":_vm.active}})
}
var staticRenderFns = []

export { render, staticRenderFns }